import { useState } from  'react';
import appConstants from '../../../../constants';

export default function useSearchRestoration() {
  const [isSearchRestorationInProgress, setIsSearchRestorationInProgress] = useState(false);
  //const [searchRestorationError, setSearchRestorationError] = useState(null);

  function restoreSearch(searchToBeRestored, selectCountryFilterValue, resetSelectedSuggestionFromSearchCriteria, errorNotificationFn) {
    setIsSearchRestorationInProgress(previousValue => true);
    try {
      const searchCriteria = searchToBeRestored.searchCriteria;
      if(!!searchCriteria && !!searchCriteria.length) {
        let countryFilterValue = searchCriteria.filter(searchCriterion => searchCriterion[appConstants.KEY_TYPE] === appConstants.VALUE_LOCATION);
        if(!!countryFilterValue.length) {
          selectCountryFilterValue(countryFilterValue[0]);
        }
        resetSelectedSuggestionFromSearchCriteria(searchCriteria);
      }
      //searchCriteria.forEach((searchCriterion) => {
      //  let updatedSearchCriterion = {...searchCriterion};
      //  updatedSearchCriterion[appConstants.KEY_IS_SELECTED] = true;
      //  suggestionTypeSubTypeSelectFnMapping[`${searchCriterion[appConstants.KEY_TYPE]}-${searchCriterion[appConstants.KEY_SUBTYPE]}`](updatedSearchCriterion);
      //});
    }
    catch(error) {
      console.error(error);
      if (!!errorNotificationFn && ('function' === typeof errorNotificationFn)) {
        errorNotificationFn();
      }
    }
    setIsSearchRestorationInProgress(previousValue => false);
  }

  return { isSearchRestorationInProgress, restoreSearch }
}
